export { default as localStorageProvider } from "./lib/LocalStorageProvider"
export * from "./lib/IStorageProvider"
export * from "./lib/StorageObject"
